'use strict';

module.exports = {
    endpointNoDevice: 'Endpoint is not associated with a device',
    endpointMissingDeviceConnectivity: 'Endpoint device has no connectivity information',
    endpointDeviceNotConnected: 'Endpoint device not connected',
    endpointDeviceNotActivated: 'Endpoint device not activated',
    endpointMissingRelayConnectivity: 'Endpoint relay has no connectivity information',
    endpointRelayNotConnected: 'Endpoint relay not connected',
    endpointRelayNotActivated: 'Endpoint relay not activated',
    partnerEndpointWarning: 'Partner endpoint may not work as expected',
    partnerEndpointError: 'Partner endpoint is in error'
};